export class AdminUserModel {
    constructor(data) {
        this.rowId = data.rowId;
        this.userId = data.userId;
        this.userEntityId = data.userEntityId;
        this.email = data.email;
        this.lastLoginAt = data.lastLoginAt;
        this.fullName = data.fullName;
        this.entityId = data.entityId;
        this.entityName = data.entityName;
        this.hasUploaded = data.hasUploaded;
        this.lastUploadDate = data.lastUploadDate;
        this.canLogin = data.canLogin;
    }
}